import type { Form } from './FormEditor.types';
import { combineUrlSegments } from '@shared/utils/combineUrlSegments';

export const getHtml = (id: string, form: Form, currentAccount: any) => {
    if (!id) return { htmlCss: '' };

    let formContainerEl = document.getElementById('form-container-' + id);
    let formEl = formContainerEl && formContainerEl.querySelector('form');

    if (!formContainerEl || !formEl) return { htmlCss: '' };

    let htmlCss = cleanHtml(formContainerEl.outerHTML);
    let html = cleanHtml(formEl.outerHTML, true);

    return {
        htmlCss: htmlCss,
        html: addBreaks(html),
        js: form ? getJsCode(id, form, currentAccount) : '',
    };
};

export const addBreaks = (plainHtml: string) => {
    const regexLabels = /\<label.*?\>.*?\<\/label\>?/gm;
    const regexInputs = /\<input.*?\>.*?\>?/gm;
    const regexSelects = /\<select.*?\>.*?\>?/gm;

    plainHtml.match(regexLabels)?.forEach((match: string) => {
        if (match.includes('type="checkbox"') || match.includes('type="radio"')) plainHtml = plainHtml.replace(match, match + '<br>');
    });

    plainHtml.match(regexInputs)?.forEach((match: string) => {
        let types = ['email', 'text', 'tel', 'date', 'number'];
        types.forEach((type) => {
            if (match.includes('type="' + type + '"')) plainHtml = plainHtml.replace(match, match + '<br>');
        });
    });

    plainHtml.match(regexSelects)?.forEach((match: string) => {
        plainHtml = plainHtml.replace(match, match + '<br>');
    });

    return plainHtml;
};

export const cleanHtml = (html: string, plain?: boolean) => {
    html = html
        .replace(/\sdata-v-(.*?)\=\"\"/g, '') // remove Vue stuff
        .replace(/<!--v-if-->/g, '') // remove Vue stuff
        .replace(/<!---->/g, '') // remove Vue stuff
        .replaceAll('<span><style>', '<style>') // remove style wrappers
        .replaceAll('</style></span>', '</style>') // remove style wrappers
        .replaceAll('class="list-move"', '')
        .replaceAll('class=""', '')
        .replaceAll('style=""', '');

    if (plain) html = html.replace(/<div(.*?)>/g, '').replace(/<\/div>/g, ''); // remove all attr from divs

    return html;
};

export const getJsCode = (id: string, form: Form, currentAccount: any) => {
    return `const formEl = document.getElementById('form-${id}');
            formEl.addEventListener('submit', function (event) {
                event.preventDefault();
                let formData = new FormData(formEl);
            });
            formEl.addEventListener("formdata", (event) => {
                let formData = event.formData;
                let url = '${combineUrlSegments(currentAccount.PublicEventUrl.PublicHost, 'Api', 'Subscriptions', '' + currentAccount.AccountId)}';

                let subscription = {
                    ListIds: [],
                    Contact: {},
                        ${form.defaultCountryCode ? "DefaultCountryCode: '" + form.defaultCountryCode + "'," : ''}
                        ${form.sourceName ? "SourceName: '" + form.sourceName + "'," : ''}
                        ${form.consent ? "ConsentText: '" + form.consent + "'," : ''}
                        ${form.confirmationIssueId ? "ConfirmationIssue: { IssueId: '" + form.confirmationIssueId + "' }," : ''}
                        ${form.subscriptionConfirmedUrl ? "SubscriptionConfirmedUrl: '" + form.subscriptionConfirmedUrl + "'," : ''}
                        ${form.subscriptionFailedUrl ? "SubscriptionFailedUrl: '" + form.subscriptionFailedUrl + "'," : ''}
                        ${form.doubleOptInIssueId ? "DoubleOptIn: { Issue: { IssueId: '" + form.doubleOptInIssueId + "' } }" : ''}
                };

                for (let entry of formData.entries()) {
                    let key = entry[0];
                    let val = entry[1];

                    if (key.startsWith('Contact[')) {
                        key = key.replace('Contact[', '').replace(']', '');
                        val = subscription.Contact[key] ? subscription.Contact[key] + ', ' + val : val;
                        subscription.Contact[key] = val;
                    }

                    if (key === 'ListIds') {
                        subscription.ListIds.push(val);
                    }
                }

                if (subscription.ListIds.length === 0) {
                    alert('Select at least one list!');
                } else {
                    let xhr = new XMLHttpRequest();
                    xhr.onreadystatechange = function () {
                        if (this.readyState == XMLHttpRequest.DONE && this.status == 200) {
                            document.location = '${form.doubleOptInUrl}'
                        }
                        if (this.readyState == XMLHttpRequest.DONE && this.status != 200) {
                            document.location = '${form.subscriptionFailedUrl}'
                        }
                    };
                    xhr.open('POST', url + '/ajax', true);
                    xhr.setRequestHeader('Content-Type', 'application/json');
                    xhr.send(JSON.stringify(subscription));
                    alert('Thanks for subscribing!');
                }
            });`;
};

export const removeItemFromList = (list: Array<any>, index: number) => {
    list.splice(index, 1);
};

export const changeOrderOfListItems = (list: Array<any>, from: number, to: number, cb?: Function | undefined) => {
    let itemToMove = list.splice(from, 1)[0];
    moveListItemToNewPos(list, itemToMove, to, cb);
};

export const moveListItemToNewPos = (list: Array<any>, listItem: { [key: string]: string }, to: number, cb?: Function | undefined) => {
    setTimeout(() => {
        list.splice(to, 0, listItem);
        if (cb) cb();
    }, 300);
};

export const addItemToList = (list: Array<any>, item: any) => {
    list.push(item);
};

export const getKeyValById = (id: string | null, searchList: Array<any>, idKeyName: string, keyName: string) => {
    if (!id) return '';
    let match = searchList.find((list) => list[idKeyName] === id);
    return match ? match[keyName] : '';
};
